module.exports = __webpack_public_path__ + "img/nodejslogo.392feb41.png";